module.exports = __webpack_public_path__ + "img/anthem-bcbs-logo.2c626a66.png";